.row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--size-control-sm);
}

.box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: var(--size-icon);
  height: var(--size-icon);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  background: var(--color-surface);
}

.box[data-state="checked"],
.box[data-state="indeterminate"] {
  border-color: var(--color-accent);
  background: var(--color-accent);
  color: var(--color-accent-fg);
}

.box:disabled {
  opacity: 0.5;
}

.indicator {
  display: inline-flex;
}

.indicator svg {
  width: var(--size-icon-sm);
  height: var(--size-icon-sm);
}

.label {
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: var(--space-2);
  cursor: pointer;
  user-select: none;
}

.labelHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}

.hint {
  color: var(--color-fg-muted);
  font-size: var(--text-sm);
}
